export default __webpack_public_path__ + "static/media/mint_logo.3e2cabe8.svg";